import { registryApi, walterApi } from '../clients/AxiosClients'

/**
 * Retorna todos os estratos inventario qualidade cadastradas no banco de dados
 */
export const getAllEstratoInventarioQualidade = async () => {
	return registryApi.get('v1/EstratoInventarioFlorestalDeQualidade')
}

/**
 * Cadastrar novo estrato inventario qualidade no banco de dados
 * @param {Object} body Estrato inventario qualidade que será cadastrada
 */
export const processarEstratoInventarioQualidade = async (body) => {
	return walterApi.post(
		'/ProcessamentoInventarioDeQualidade/processar-inventario-de-qualidade',
		body,
	)
}

/**
 * Processa o qualidade para inventario florestal tradicional
 * @param {Object} body Estrato de inventario florestal que sera processado qualidade
 */
export const processarQualidadeParaInventarioTradicional = async (body) => {
	return walterApi.post(
		'/ProcessamentoInventarioDeQualidade/processar-qualidade-para-inventario-tradicional',
		body,
	)
}

/**
 * Atualiza Estrato inventario qualidade no banco de dados
 * @param {Object} body Estrato inventario qualidade que será atualizada
 */
export const updateEstratoInventarioQualidade = async (idInventarioQualidade, body) => {
	return registryApi.put(`v1/EstratoInventarioFlorestalDeQualidade/${idInventarioQualidade}`, body)
}

/**
 * Lista dos ids de Estrato inventario qualidade que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de Estrato inventario qualidade
 */
export const deleteEstratoInventarioQualidadeByIdList = async (data) => {
	return registryApi.delete('v1/EstratoInventarioFlorestalDeQualidade', {
		data,
	})
}
